export const getUrl = (path: any) => {
    return process.env.REACT_APP_BASE_URL + path
}